import { gql } from 'graphql-request'

export const ManySearchQuery = gql`
  # sort
  query AllSearch(
    $limit: Int! = 100,
    $page:Int! = 1,
    $locale: LocaleInputType!
    $sort: String = "title, priority"
    $query: String
    $now: DateTime!
  ) {
    Searches(
      limit: $limit,
      sort: $sort,
      page: $page,
      locale: $locale,
      where: {
        AND: [
          { title: { like: $query } }
          {
            # entries with no expiry are permanent; the rest drop out on their
            # derived visibleUntil date. Both "missing" and "explicitly null"
            # are matched -- older records predate the field.
            OR: [
              { visibleUntil: { exists: false } }
              { visibleUntil: { equals: null } }
              { visibleUntil: { greater_than_equal: $now } }
            ]
          }
        ]
      },
    ) {
      docs {
        id
        title
        priority
        doc {
          relationTo
          value {
            ... on Page {
              id
              title
              slug
              group {
                docs {
                  id
                }
              }
            }
            ... on News {
              id
              title
              slug
            }
            ... on Programme {
              id
              title
              slug
            }
            ... on Person {
              id
              title
              slug
            }
            ... on Room {
              id
              title
              slug
            }
            ... on GlobalPage {
              id
              title
              globalType
            }
          }
        }
      }
      totalDocs
      limit
      totalPages
      page
      pagingCounter
      hasPrevPage
      hasNextPage
      prevPage
      nextPage
    }
  }
`
